import { createRoutine } from 'redux-saga-routines';

import LandingPageTokenConstants from 'spa/constants/LandingPageTokenConstants';

export const fetchTokenCustomerDetails = createRoutine(
  LandingPageTokenConstants.FETCH_TOKEN_CUSTOMER_DETAILS
);

export const fetchTokenReturnUrl = createRoutine(LandingPageTokenConstants.FETCH_TOKEN_RETURN_URL);
